import { render, staticRenderFns } from "./TolRouteDetail.vue?vue&type=template&id=d6b1715c&scoped=true"
import script from "./TolRouteDetail.vue?vue&type=script&lang=js"
export * from "./TolRouteDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b1715c",
  null
  
)

export default component.exports